import React from 'react';

import type { PagesQuery } from '../../graphql/generated/schema';
import { BlockSettings_Margin_MarginBottom, BlockSettings_Padding_PaddingLeft, BlockSettings_Padding_PaddingRight } from '../../graphql/generated/schema';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import { BlockContainer } from '../../components/layouts';
import { RenderBlocks } from '../../components';
import styles from './styles.module.scss';
import { constructClassName } from '../../utils/constructClassName';

export const CardWithBlocks: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'CardWithBlocks'>> = ({
  color,
  blocks,
  blockSettings,
  hasBorder,
}) => {
  const colors = () => {
    switch (color) {
      case 'light':
        return styles.containerLight;
      case 'secondary':
        return styles.containerSecondary;
      case 'white':
        return styles.containerWhite;
      case 'dark':
        return styles.containerDark;
      default:
        return styles.container;
    }
  };

  return (
    <BlockContainer
      blockSettings={blockSettings}
      className={constructClassName([
        styles.container,
        colors(),
        Boolean(hasBorder) && styles.containerSecondaryBorder,
      ])}
    >
      <RenderBlocks
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        blocks={blocks as any}
        blockSettings={{
          margin: {
            // eslint-disable-next-line camelcase
            marginBottom: BlockSettings_Margin_MarginBottom.None,
          },
          padding: {
            // eslint-disable-next-line camelcase
            paddingLeft: blockSettings?.padding?.paddingLeft === BlockSettings_Padding_PaddingLeft.None ? undefined : BlockSettings_Padding_PaddingLeft.None,
            // eslint-disable-next-line camelcase
            paddingRight: blockSettings?.padding?.paddingRight === BlockSettings_Padding_PaddingRight.None ? undefined : BlockSettings_Padding_PaddingRight.None,
          },
        }}
      />
    </BlockContainer>
  );
};
